import React from "react";
import { toggle } from "../../../../util/common";
import CompanyInformationDetails from "./CompanyInformationDetails";
import CompanyInformationGroupStructure from "./CompanyInformationGroupStructure";
import CompanyInformationBusinessLicense from "./CompanyInformationBusinessLicense";
import CompanyInformationCorporateOfficer from "./CompanyInformationCorporateOfficer";
import { BusinessCreditReportStatePII } from "../../../../store/businessCreditReportService/types";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
    creditProvider?: any;
}

const CompanyInformation: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div className="drawer-container">
                <div className="drawer-header">
                    {props.showAsAccordion ? (
                        <button
                            aria-expanded="false"
                            className="btn-default btn-toggle btn-drawer"
                            id="btn-company-information"
                            onClick={() => toggle("company-information", "btn-company-information")}
                        >
                            <span className="btn-toggle-status sr-only">Show</span>
                            <span className="btn-text">Company Information</span>
                        </button>
                    ) : (
                        <h3>Company Information</h3>
                    )}
                </div>

                <div className="drawer-content" id="company-information" style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}>
                    <div role="list" className="data-grid has-lines margin-top-s" id="">
                        <CompanyInformationDetails reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        <CompanyInformationGroupStructure reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        {props.creditProvider !== "DUNBRADSTREET" && (
                            <CompanyInformationBusinessLicense reportObject={props.reportObject} showAsAccordion={props.showAsAccordion} />
                        )}
                        <CompanyInformationCorporateOfficer
                            reportObject={props.reportObject}
                            showAsAccordion={props.showAsAccordion}
                            creditProvider={props.creditProvider}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyInformation;
